<template>
  <app-echart-bar
    v-if="items.length"
    :key="chartKey"
    :option-data="chartOption"
    class="mb-2"
    style="height: 320px; width: 100%;"
  />
</template>

<script>
import AppEchartBar from '@core/components/charts/echart/AppEchartBar.vue'

export default {
  name: 'HomeStoreSalesChart',
  components: { AppEchartBar },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    period: {
      type: String,
      default: '',
    },
  },
  computed: {
    chartKey() {
      if (!this.items.length) return 'store-sales-empty'
      const signature = this.items
        .map(item => [
          item.store_id,
          item.count,
          item.sum_quantity,
          item.sum_total_price,
          item.sum_total_sales_price,
        ].join('-'))
        .join('|')
      return `${this.period}-${signature}`
    },
    chartOption() {
      const labels = this.items.map(item => item.store_name || `#${item.store_id}`)
      const orders = this.items.map(item => Number(item.count) || 0)
      const quantities = this.items.map(item => Number(item.sum_quantity) || 0)
      const totals = this.items.map(item => Number(item.sum_total_price) || 0)
      const sales = this.items.map(item => Number(item.sum_total_sales_price) || 0)

      return {
        grid: {
          left: '40px',
          right: '40px',
          top: '40px',
          bottom: '50px',
          containLabel: false,
        },
        xAxis: [
          {
            type: 'category',
            data: labels,
            axisLabel: {
              rotate: 20,
              fontSize: 10,
              interval: 0,
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            position: 'left',
            name: 'Siparis / Adet',
            nameLocation: 'middle',
            nameGap: 45,
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#e0e0e0',
              },
            },
          },
          {
            type: 'value',
            position: 'right',
            name: 'Tutar (₺)',
            nameLocation: 'middle',
            nameGap: 55,
            splitLine: { show: false },
            axisLabel: {
              formatter: value => {
                if (value >= 1000) return `${(value / 1000).toFixed(0)}k ₺`
                return `${value} ₺`
              },
            },
          },
        ],
        series: [
          {
            name: 'Siparis',
            type: 'bar',
            data: orders,
            yAxisIndex: 0,
            barMaxWidth: 28,
          },
          {
            name: 'Adet',
            type: 'bar',
            data: quantities,
            yAxisIndex: 0,
            barMaxWidth: 28,
          },
          {
            name: 'Toplam',
            type: 'bar',
            data: totals,
            yAxisIndex: 1,
            barMaxWidth: 28,
          },
          {
            name: 'Satis',
            type: 'bar',
            data: sales,
            yAxisIndex: 1,
            barMaxWidth: 28,
          },
        ],
      }
    },
  },
}
</script>
